export default "__VITE_ASSET__U$9o8xBJ__"